

function generateLocalId() {
    return Math.random().toString(36).substring(2, 7) + Math.random().toString(36).substring(2, 7);
}

function generateSessionId() {
    return Math.random().toString(36).substring(2, 7) + Math.random().toString(36).substring(2, 7);
}


class SessionService {

    localId = null;
    sessionId = null;
    clientId = null;

    constructor() {

        if(sessionStorage && sessionStorage.sessionId) {
            this.sessionId = sessionStorage.sessionId;
        } else {
            this.sessionId = generateSessionId();
            sessionStorage.sessionId = this.sessionId;
        }

        if(localStorage && localStorage.localId) {
            this.localId = localStorage.localId;
        } else {
            this.localId = generateLocalId();
            localStorage.localId = this.localId;
        }

        if(localStorage && localStorage.clientId) {
            this.clientId = localStorage.clientId;
        } else {
            let timestamp = Date.now();
            let timestampHex = timestamp.toString(16);
            this.clientId = `${timestampHex}-${this.localId}-${this.sessionId}`;
            localStorage.clientId = this.clientId;
        }


    }

    getClientId() {
        return this.clientId;
    }
    
    

}

export default new SessionService();